import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, shouldCapitalize: boolean = true): string {
    if (shouldCapitalize) {
        if (!value) return value;

        const items = value.split(', ');
    
        const capitalizedItems = items.map(item => {
          return item.charAt(0).toUpperCase() + item.slice(1);
        });
    
        return capitalizedItems.join(', ');
    }
    else{
        return value
    }
  }
}
